/**
 * Created by xixue on 2019/1/11.
 */
export default {
  // 注册的主题
  releases: {
    version: 'v3'
  },
  theme: {
    list: [
      {
        title: '默认',
        name: 'default',
        preview: 'image/theme/d2/preview@2x.png'
      },
      {
        title: '数学',
        name: 'math',
        preview: 'image/theme/d2/preview@2x.png'
      },
      {
        title: '英语',
        name: 'en',
        preview: 'image/theme/d2/preview@2x.png'
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/register.js